import { round } from 'lodash';

/**
 * Resolves the distance for a comparable property using a fallback strategy:
 * 1. Use Rapid distance if available
 * 2. Use the provided calculated distance if available
 * 3. Return null if neither is available
 *
 * @param {number|null|undefined} rapidDistance - Distance from Rapid API response
 * @param {number|null|undefined} calculatedDistance - Distance calculated from coordinates
 * @returns {number|null} Distance in km or null
 */
export const resolveDistance = (rapidDistance, calculatedDistance) => {
  if (rapidDistance !== null && !isNaN(rapidDistance)) {
    return round(Number(rapidDistance), 2);
  }

  if (calculatedDistance !== null && !isNaN(calculatedDistance)) {
    return round(Number(calculatedDistance), 2);
  }

  return null;
};
